
import { MaintenanceAspectEntityDecorator } from './maintenance-aspect.decorator';
import { MaintenanceAspect } from './maintenance-aspect.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class MaintenanceAspectTypeInfoBase implements CrudTypeInfo<MaintenanceAspect, number> {
  name = 'Maintenance Aspect';
  entityDecorator = new MaintenanceAspectEntityDecorator();
  
  createAuthorities = ['WRITE_MAINTENANCE_ASPECT'];
  editAuthorities = ['WRITE_MAINTENANCE_ASPECT'];
  deleteAuthorities = ['WRITE_MAINTENANCE_ASPECT'];
  viewAuthorities = ['READ_MAINTENANCE_ASPECT'];
  
  searchRouteBase = ['/maintenanceaspect/search'];
  createRouteBase = ['/maintenanceaspect/create'];
  editRouteBase = ['/maintenanceaspect/edit'];
  viewRouteBase = ['/maintenanceaspect/view'];
  
  description(item: MaintenanceAspect): string {
    return '' +  item.aspectAssetId;
  }
}



